import { render } from "./ListGroup.vue?vue&type=template&id=0bf5f641&scoped=true&lang=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"

import "./ListGroup.vue?vue&type=style&index=0&id=0bf5f641&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bf5f641"

export default script